import React, { useCallback, useState } from 'react'
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import Resx from '@/components/Resx'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { processDesignerReport } from '@/store/utils/reportUtils'
import { serializeForJsonFile } from '@/components/reportDesigner/utils'
import saveAs from 'file-saver'
import { openErrorDialog } from '@/utils/dialogHelpers'

const DownloadVersionDefinitions = React.memo(function ({ templateVersionId }) {
  const [isOpen, setIsOpen] = useState(false)
  const { localize, localizeValue } = useLocalization()

  const isOpenToggle = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  const getDefinitionJson = useCallback(() => {
    context.api.reportTemplateService.exportTemplate(templateVersionId)
      .then(processDesignerReport)
      .then(serializeForJsonFile)
      .then(json => {
        const result = JSON.parse(json)
        const blob = new window.Blob([json], { type: 'application/json;charset=utf-8' })
        const name = localizeValue(result.name, result.latinName)
        saveAs(blob, `${name}.json`)
      })
      .catch(() => openErrorDialog())
  }, [templateVersionId, localizeValue])

  const getDefinitionXml = useCallback(() => {
    context.api.reportTemplateService.exportTemplate(templateVersionId)
      .then(processDesignerReport)
      .then(serializeForJsonFile)
      .then(json => {
        context.api.reportTemplateService.convertToXml(json)
          .then(response => {
            const report = JSON.parse(json)
            const blob = new window.Blob([response], { type: 'application/xml;charset=utf-8' })
            const name = localizeValue(report.name, report.latinName)
            saveAs(blob, `${name}.xml`)
          })
          .catch(() => openErrorDialog())
      })
      .catch(() => openErrorDialog())
  }, [templateVersionId, localizeValue])

  return <ButtonDropdown isOpen={isOpen} toggle={isOpenToggle}>
    <DropdownToggle caret>
      <Resx name={'Reporting.GetReportDefinition'} />
    </DropdownToggle>
    <DropdownMenu>
      <React.Fragment>
        <DropdownItem onClick={getDefinitionJson}>{localize('Common.Json')}</DropdownItem>
        <DropdownItem onClick={getDefinitionXml}>{localize('Common.Xml')}</DropdownItem>
      </React.Fragment>
    </DropdownMenu>
  </ButtonDropdown>
})

export { DownloadVersionDefinitions }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/report-templates/downloadVersionDefinitions.js